export const LATEST_NEWS_SEEN = 'latestNewsSeen';
